import { LinkProps } from '@repo/ui/src/types/link';
import Button from '@repo/ui/src/components/Button';
import { getButtonVariant } from '@repo/ui/src/components/Button/utils';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';

interface Props {
  grillRecommendation: {
    grillRecommendation: any;
    answers: any;
    button: {
      link: LinkProps;
      style?: string;
      icon?: string;
    };
  };
  dark?: boolean;
  buttonSize?: 'large' | 'medium' | 'small' | 'none';
}

const GrillRecommendationButton = ({ grillRecommendation, dark, buttonSize }: Props) => {
  const { push } = useModal(ModalID.grillRecommendation);
  if (!grillRecommendation?.grillRecommendation) return null;

  return (
    <Button
      {...grillRecommendation?.button?.link}
      variant={getButtonVariant(
        grillRecommendation?.button?.style,
        grillRecommendation?.button?.icon,
      )}
      dark={dark}
      size={buttonSize}
      onClick={() => push(grillRecommendation)}
    >
      {grillRecommendation?.button?.link?.displayName}
    </Button>
  );
};

export default GrillRecommendationButton;
